import React, { useState } from "react"
import styles from "@/components/core/AutoSuggestion/v1/index.module.scss"
import {
  ZIP_CODE_DIGIT_REGEX,
  ZIP_CODE_MATCH_WHITESPACE_REGEX,
} from "@/constants/regex"

const AutoSuggestion = ({
  id,
  borderValue,
  placeholderLabel,
  prefix,
  suffix,
  optionList,
  ariaLabel,
  selectedValue,
  iconAnalyticsdata,
  handleSelect,
  handleChange,
  title = "",
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const getInputVal = item => {
    const value = item
      .replace(ZIP_CODE_MATCH_WHITESPACE_REGEX, "")
      .match(ZIP_CODE_DIGIT_REGEX)
    const inputVal = value != null ? value[0] : item
    handleChange(inputVal)
    setIsOpen(true)
  }

  const getSuggestionVal = item => {
    handleSelect(item)
    setIsOpen(false)
  }

  document.addEventListener("click", function (e) {
    if (
      setIsOpen &&
      !document.getElementById(`${id}-wrapper`)?.contains(e.target)
    )
      setIsOpen(false)
  })

  return (
    <React.Fragment>
      <div className={styles.autoSuggetionWrapper}>
        <div className="auto-suggestion">
          <div
            className={`auto-suggestion__input-container ${
              borderValue === "bottom"
                ? "auto-suggestion__border-bottom"
                : "auto-suggestion__border-all"
            }`}
          >
            {prefix !== undefined && (
              <div className="auto-suggestion__input-field-prefix">
                {prefix}
              </div>
            )}
            <input
              type="text"
              className="auto-suggestion__input"
              placeholder={placeholderLabel}
              value={selectedValue}
              onChange={e => getInputVal(e.target.value)}
              aria-label={ariaLabel}
              onBlur={() => setIsOpen(false)}
              title={title}
            />
            {suffix !== undefined && (
              <div
                className={
                  "auto-suggestion__input-field-suffix " +
                  (iconAnalyticsdata ? "gbh-data-layer" : "")
                }
                data-gbh-data-layer={iconAnalyticsdata || null}
              >
                {suffix}
              </div>
            )}
          </div>
          <div
            className={`auto-suggestion__dropdown ${isOpen ? " active" : ""}`}
          >
            {optionList?.length > 0 && (
              <ul className="auto-suggestion__dropdown-items">
                {optionList.map((item, i) => (
                  <li
                    key={i}
                    onMouseDown={() => getSuggestionVal(item)}
                    className="auto-suggestion__dropdown-item"
                  >
                    <span className="auto-suggestion__dropdown-item-value">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AutoSuggestion
